import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { Events, subscribe } from "../utils/Belt";
// Shown under the app bar (so on every drawer page) once a new version has taken over.
export default function UpdateBanner() {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    useEffect(() => {
        subscribe(Events.AppUpdateAvailable, () => {
            setUpdateAvailable(true);
        });
    }, []);
    if (!updateAvailable) {
        return null;
    }
    return (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', py: 1, bgcolor: 'warning.light' } },
        React.createElement(Button, { variant: "contained", color: "warning", onClick: () => window.location.reload() }, "Refresh app")));
}
